package com.devi3east.bashbuddy.features.events.common.data.models

import kotlinx.serialization.Serializable

@Serializable
enum class EventType {
    FEATURED,
    REGULAR
}